module.exports = __webpack_public_path__ + "img/loader.42e390e3.svg";